import React from 'react';
import { cn } from '@/utils';

export function RapidaTextIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      className={cn('w-auto h-6', props.className)}
      viewBox="0 0 1080 214"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <image
        href="/images/logos/logo-01.png"
        x="0"
        y="0"
        width="1080"
        height="214"
        preserveAspectRatio="xMidYMid meet"
      />
    </svg>
  );
}